import { Button } from "@/components/ui/button";
import { useCart } from "@/contexts/CartContext";
import { ShoppingBag } from "lucide-react";

type CartButtonProps = {
  className?: string;
  label?: string;
};

export function CartButton({ className, label = "Cart" }: CartButtonProps) {
  const { itemCount, openCart } = useCart();

  return (
    <Button
      type="button"
      onClick={openCart}
      variant="outline"
      className={className ?? "border-white/12 bg-white/5 text-white hover:bg-white/10"}
    >
      <ShoppingBag className="mr-2 h-4 w-4" />
      {label}
      <span className="ml-3 inline-flex min-w-6 items-center justify-center rounded-full bg-[#c2ff45] px-2 py-0.5 text-xs font-semibold text-[#07110f]">
        {itemCount}
      </span>
    </Button>
  );
}
